import { useEffect } from 'react';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import WhatsAppFloat from '@/pages/home/components/WhatsAppFloat';
import AllVehiclesList from './components/AllVehiclesList';
import { applySeo } from '@/lib/seo';

export default function VehiclesPage() {
  useEffect(() => {
    applySeo({
      title: "Voitures d'occasion à La Réunion | Easy Car",
      description: "Découvrez les véhicules d'occasion disponibles chez Easy Car à La Réunion, au Tampon et à Saint-Pierre. Consultez notre catalogue de voitures révisées.",
      canonical: "https://easycar.re/vehicules",
    });

    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main className="pt-20 md:pt-24">
        <AllVehiclesList />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
